import { emoji } from '@/framework/directive/index'

/**
 * 去除头部和尾部多余的0
 * @param {String} val 原始值
 * @returns 处理后的值
 */
export const trimZero = (val, noZero) => {
  if (val === '') return val
  let newValue = val
  // 小数需要分情况处理
  if (newValue.indexOf('.') >= 0) {
    // 去除结尾和开头的0
    newValue = newValue.replace(/\.?0+$/, '').replace(/^[0]+/, '')
    if (newValue === '.') {
      newValue = ''
    } else if (newValue.indexOf('.') === 0) {
      newValue = `0${newValue}`
    } else if (newValue.indexOf('.') === newValue.length - 1) {
      newValue = newValue.substr(0, newValue.length - 1)
    }
  } else {
    // 整数去除头部的0即可
    newValue = newValue.replace(/\b(0+)/gi, '')
  }
  if (newValue === '' && !noZero) newValue = '0'
  return newValue
}

/**
 * 限制整数+小数
 * @param {*} value 原始值
 * @param {*} integerDigits 整数位数
 * @param {*} DecimalDigits 小数位数
 * @returns 格式化后的值
 */
export const limitFloat = (value, integerDigits = 8, DecimalDigits = 2) => {
  // 去除非数字和小数点的其他字符
  let newValue = emoji(value.replace(/[^0-9.]/g, ''))
  if (newValue.indexOf('.') >= 0) {
    const valueArr = newValue.split('.')
    const valInteger = valueArr[0] ? valueArr[0].substr(0, integerDigits) : ''
    const valDecimal = valueArr[1] ? valueArr[1].substr(0, DecimalDigits) : ''
    newValue = `${valInteger}.${valDecimal}`
    // 小数点开头时补充整数位0
    if (newValue.startsWith('.')) {
      newValue = `0${newValue}`
    }
  } else {
    newValue = newValue.substr(0, integerDigits)
  }
  return newValue
}

/**
 * 限制整数&长度
 * @param {Number} value 值
 * @param {*} length 长度
 * @returns 格式化后的值
 */
export const limitInteger = (value, length = 18) => {
  return emoji(value.replace(/\D/g, '')).substr(0, length)
}
